<template>
    <div>
        <el-row type="flex" class="row-bg" justify="end">
            <el-col :span="6" :offset="14" style="text-align: right; padding-right: 10px;">
                <el-select v-model="curKaoDianId" placeholder="选择考点进行操作..." :disabled="state">
                    <el-option v-for="(item, index) in datas" :key="item.name" :label="item.name + ' [共' + item.ids.length + '个考场]'" :value="index">
                        <span>[{{ item.name }}] - 考场数量{{ item.ids.length }}</span>
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="4">
                <el-button type="primary" icon="el-icon-printer" style="width: 100%;" @click="doPrint" :disabled="state">批量打印座次表</el-button>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="textinfo">
            <el-progress v-if="state" type="dashboard" :percentage="countAll" :color="colors"></el-progress>
            <div v-if="state" style="color: steelblue; padding-left: 20px;">正在处理中，请耐心等待..</div>
            <div v-if="state" style="color: red; padding-left: 20px;">因浏览器底层缓存机制，请手动下拉预览页至底部，以确保考生照片被完整加载</div>
            <div v-if="state" style="color: red; padding-left: 20px;">检查完成后点击任意打印按钮开始打印即可</div>
            <div v-if="curKaoDianId === ''">{{ texeinfo }}</div>
            <div v-else style="color: green;">已选中考点 [{{ datas[curKaoDianId].name }}]</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlanAllPrint',
    props: {
        pid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 9999,
                time: 0,
                name: '',
                room: '',
                rno: ''
            },
            colors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 40 },
                { color: '#5cb87a', percentage: 60 },
                { color: '#1989fa', percentage: 80 },
                { color: '#6f7ad3', percentage: 100 }
            ],
            curKaoDianId: '',
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            datas: [],
            texeinfo: '等待选择考点..',
            state: false,
            count: 0,
            countAll: 0
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.tableLoading = true
            this.query.pid = this.pid
            this.$http
                .get('/ops/recruit/venues/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    var arr = result.datas
                    if (!Array.isArray(arr)) return []
                    const newArr = []
                    arr.forEach(item => {
                        const index = newArr.findIndex(subItem => subItem.name === item.name)
                        if (index > -1) {
                            newArr[index].ids.push(item.id)
                        } else {
                            newArr.push({
                                name: item.name,
                                ids: [item.id]
                            })
                        }
                    })

                    this.datas = newArr
                })
        },

        doP(id) {
            return new Promise(resolve => {
                setTimeout(() => {
                    this.$http
                        .get('/ops/recruit/seats/zcb/print', {
                            params: {
                                _: new Date().getTime(),
                                vid: id
                            }
                        })
                        .then(result => {
                            if (result.code == 0) {
                                // this.handlePrint(result.data.info)
                                resolve(result.data.info)
                            }
                        })
                }, 600)
            })
        },
        async doPrint() {
            if (this.curKaoDianId === '') {
                this.$message.error('请选择考点')
                return
            }

            this.state = true
            let total = this.datas[this.curKaoDianId].ids.length
            let num = 0
            // this.countAll = this.datas[this.curKaoDianId].ids.length
            this.count = this.datas[this.curKaoDianId].ids.length

            let arr = []
            for (let i = 0; i < this.datas[this.curKaoDianId].ids.length; i++) {
                arr.push(await this.doP(this.datas[this.curKaoDianId].ids[i])) //await会阻塞当前异步函数的执行，等待promise返回处理结果
                this.count--
                num++
                this.countAll = total <= 0 ? '0' : Math.round((num / total) * 10000) / 100.0
            }
            this.handlePrint(arr)
        },
        handlePrint(info) {
            this.state = false
            var newWin = window.open('') //新打开一个空窗口
            newWin.document.write(info) //将需要打印的内容添加进新的窗口
            const styleSheet = `<style>li{list-style:none}</style>`
            newWin.document.head.innerHTML = styleSheet //给打印的内容加上样式
            newWin.document.close() //在IE浏览器中使用必须添加这一句
            newWin.focus() //在IE浏览器中使用必须添加这一句
            // setTimeout(function() {
            //     newWin.print() //打印
            //     newWin.close() //关闭窗口
            // }, 10000)
        }
    }
}
</script>

<style>
.el-transfer-panel {
    width: 420px !important;
}
.textinfo {
    text-align: center;
    font-size: larger;
    height: 260px;
}
.textinfo div {
    padding-bottom: 10px;
}
</style>
